interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ContactModal({ isOpen, onClose }: ContactModalProps) {
  if (!isOpen) return null;
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://jyfm-zyst.cn';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const name = formData.get('name');
    const phone = formData.get('phone');
    const message = formData.get('message');

    if (!name || !phone || !message) {
      alert('请填写所有必填项');
      return;
    }

    const submitBody = new URLSearchParams(formData as any).toString();
    void fetch(`${apiBaseUrl}/admin/baidu/convert`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: submitBody,
    })
      .then(async response => {
        let result: any = null;
        try {
          result = await response.json();
        } catch (error) {
          console.error('convert 响应解析失败:', error);
        }
        if (!response.ok || result?.status !== 'success') {
          console.error('convert 接口调用失败:', { status: response.status, result });
        }
      })
      .catch(error => {
        console.error('convert 接口调用异常:', error);
      });

    void fetch(`${apiBaseUrl}/admin/clue/store`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: submitBody,
    })
      .then(async response => {
        let result: any = null;
        try {
          result = await response.json();
        } catch (error) {
          console.error('clue 响应解析失败:', error);
        }
        if (!response.ok || result?.status !== 'success') {
          console.error('clue 接口调用失败:', { status: response.status, result });
        }
      })
      .catch(error => {
        console.error('clue 接口调用异常:', error);
      });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5fr00bgm8mddqjelo4g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: submitBody,
      });
      if (response.ok) {
        alert('提交成功，我们会尽快与您联系');
        form.reset();
        onClose();
      } else {
        alert('提交失败，请稍后重试');
      }
    } catch (error) {
      console.error('提交错误:', error);
      alert('提交失败，请稍后重试');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div className="absolute inset-0" onClick={onClose}></div>
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full animate-slideUp overflow-hidden">
        <div className="bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-8 py-6 relative">
          <button
            onClick={onClose}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-all cursor-pointer group"
          >
            <i className="ri-close-line text-2xl group-hover:rotate-90 transition-transform duration-300"></i>
          </button>
          <div className="flex items-center">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mr-4">
              <i className="ri-customer-service-2-line text-2xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold">联系我们</h3>
              <p className="text-white/90 text-sm mt-1">我们随时为您提供专业服务</p>
            </div>
          </div>
        </div>

        <div className="p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="flex items-center bg-teal-50 rounded-xl p-4 border border-teal-100">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-500 rounded-lg mr-3 flex-shrink-0">
                <i className="ri-phone-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-gray-600 mb-0.5">服务热线</p>
                <p className="text-sm font-bold text-teal-600">18123952850</p>
              </div>
            </div>

            <div className="flex items-center bg-cyan-50 rounded-xl p-4 border border-cyan-100">
              <div className="w-10 h-10 flex items-center justify-center bg-cyan-500 rounded-lg mr-3 flex-shrink-0">
                <i className="ri-mail-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-gray-600 mb-0.5">电子邮箱</p>
                <p className="text-sm font-bold text-cyan-600 break-all">18123952850@139.com</p>
              </div>
            </div>

            <div className="flex items-center bg-teal-50 rounded-xl p-4 border border-teal-100">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-500 rounded-lg mr-3 flex-shrink-0">
                <i className="ri-wechat-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-gray-600 mb-0.5">企业微信</p>
                <p className="text-sm font-bold text-teal-600">扫码添加</p>
              </div>
            </div>
          </div>

          <form className="space-y-4" data-readdy-form id="contact-form" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  您的姓名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-sm"
                  placeholder="请输入您的姓名"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  联系电话 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-sm"
                  placeholder="请输入您的联系电话"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">电子邮箱</label>
              <input
                type="email"
                name="email"
                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:border-teal-500 focus:outline-none transition-colors text-sm"
                placeholder="请输入您的邮箱"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                咨询内容 <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:border-teal-500 focus:outline-none transition-colors resize-none text-sm"
                placeholder="请描述您的需求或问题，限500字"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 text-white px-6 py-4 rounded-lg text-base font-bold shadow-lg hover:shadow-xl transition-all cursor-pointer whitespace-nowrap hover:scale-[1.02] flex items-center justify-center group"
            >
              <i className="ri-send-plane-fill mr-2 text-lg group-hover:translate-x-1 transition-transform"></i>
              提交咨询
            </button>
          </form>

          <div className="mt-6 bg-teal-50 border border-teal-100 rounded-lg p-4">
            <div className="flex items-start">
              <div className="w-6 h-6 flex items-center justify-center bg-teal-500 rounded-lg mr-3 flex-shrink-0">
                <i className="ri-information-line text-white text-sm"></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                提交后，我们的专业顾问将在 <span className="font-bold text-teal-600">24小时内</span> 与您取得联系
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
